import {cartRuleDefaults} from './defaults';
import type {CartRule} from './types';

export const createCartRule = (id: number): CartRule => ({
	...cartRuleDefaults,
	elementValue1: id,
});

export default createCartRule;
